import React from "react";
import {
  TYPE_CPD_EVENT_CATEGORY,
  useGetCpdEventCategoryAllQuery,
} from "../../api/api";
import { formSet } from "../../actions/appActions";
import { useDispatch } from "react-redux";
import { Edit } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import DataTable from "../DataTable/DataTable";

const CpdEventCategoryList = () => {
  const dispatch = useDispatch();

  const cpdEventCategoryData = useGetCpdEventCategoryAllQuery();

  const cpdEventCategories = cpdEventCategoryData.data?.["hydra:member"] || [];

  const isLoading = cpdEventCategoryData.isLoading;

  const columns = [
    {
      field: "title",
      flex: 2,
      headerName: "Název",
    },
    {
      field: "code",
      flex: 2,
      headerName: "Kód",
    },
    {
      field: "actions",
      flex: 1,
      headerName: "Akce",
      disableColumnMenu: true,
      type: "number",
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <IconButton
              onClick={() => {
                dispatch(formSet(TYPE_CPD_EVENT_CATEGORY, params.row));
              }}
              color="primary"
              size="small"
            >
              <Edit fontSize="inherit" />
            </IconButton>
          </>
        );
      },
    },
  ];
  //
  return (
    <>
      <DataTable
        columns={columns}
        rows={cpdEventCategories}
        autoHeight={true}
        loading={isLoading}
      />
    </>
  );
};

export default CpdEventCategoryList;
